import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = () => api.get("/products").then((r) => r.data);
export const fetchProduct = (idOrSlug) =>
  api.get(`/products/${idOrSlug}`).then((r) => r.data);

export const submitInquiry = (payload) =>
  api.post("/inquiries", payload).then((r) => r.data);

export const createCheckoutSession = (product_id) =>
  api
    .post("/checkout/session", {
      product_id,
      origin_url: window.location.origin,
    })
    .then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
